/**
 * Telephony account status (Prompt 1.13) — metadata only, never secrets.
 * 404 while the backend runs with TELEPHONY_ENABLED=false.
 */
import { get, put } from '@core/api/client';
import { endpoints } from '@core/api/endpoints';

export interface TelephonySelfSummary {
  /** Platform-managed subaccount (created on first number purchase). */
  managed: { configured: boolean; status: string | null };
  /** Tenant's own Twilio account (bring-your-own). */
  byo: {
    configured: boolean;
    status: string | null;
    lastValidatedAt: string | null;
  };
}

export interface TelephonySettings {
  /** Recordings older than this are deleted (default 90). */
  recordingRetentionDays: number;
  /** Call transcripts older than this are erased; null = kept (4.4). */
  transcriptRetentionDays?: number | null;
  /** false: the default applies (never saved). */
  custom: boolean;
  updatedAt: string | null;
}

export const telephonyService = {
  getSelf(): Promise<TelephonySelfSummary> {
    return get<TelephonySelfSummary>(endpoints.telephony.accountSelf);
  },
  getSettings(): Promise<TelephonySettings> {
    return get<TelephonySettings>(endpoints.telephony.settings);
  },
  updateSettings(payload: {
    recordingRetentionDays?: number;
    transcriptRetentionDays?: number | null;
  }): Promise<TelephonySettings> {
    return put<TelephonySettings>(endpoints.telephony.settings, payload);
  },
} as const;
